export interface GroupedProgressRowHeaderProps {
    /** Label for this group (e.g. department, team, role, organization). */
    groupLabel: string;
    /** Completed count (numerator for the fraction). */
    completedCount: number;
    /** Total count (denominator for the fraction). */
    totalCount: number;
}

export const GroupedProgressRowHeader = ({
    groupLabel,
    completedCount,
    totalCount,
}: GroupedProgressRowHeaderProps) => (
    <div className="grouped-progress__row-header">
        <span className="body2 text-high-emphasis">{groupLabel}</span>
        <span className="body2 text-medium-emphasis">{completedCount}/{totalCount}</span>
    </div>
);

export default GroupedProgressRowHeader;
